'use client'

import FloatBetslip from "@/components_mobile/float/betslip";
import { betDetailTypes, BetslipTypes, marketType, membersType, selectionType, ticketsTypes } from "@/type/sports";
import api from "@/util/api";
import customAlert from "@/util/customAlert";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { AuthContext } from "./authContext";
import FloatBetDetail from "@/components_mobile/float/bet-detail";
import getQueryString from "@/util/queryString";
import { useTranslations } from "next-intl";

interface BetContextTypes {
    betTickets: ticketsTypes[]
    SetBetTickets: (match_id: number, match_date:string, members: membersType[], markets: marketType, selections: selectionType) => void
    clearTicket: Function

    betSlipShow: boolean
    setBetslipShow: Function
    betDetailShow: boolean
    setBetDetailShow: Function

    betslipInfo: BetslipTypes
    addBetPoint: Function
    setBetslipInfo: Function
    deleteSelection: Function

    fetchBetDetails: Function
    detailList: betDetailTypes[]
    totalCount: number
    deleteAllBetTickets: Function

    LetsBet: Function
}
export const BetContext = createContext<BetContextTypes>({
    betTickets: [],
    SetBetTickets: () => { },
    clearTicket: () => { },

    betSlipShow: false,
    setBetslipShow: () => { },
    betDetailShow: false,
    setBetDetailShow: () => { },

    betslipInfo: {
        bet_point: 0,
        total_odds: 1,
        expected_point: 0
    },
    addBetPoint: () => { },
    setBetslipInfo: () => { },
    deleteSelection: () => { },

    fetchBetDetails: () => { },
    detailList: [],
    totalCount: 1,
    deleteAllBetTickets: ()=> {},

    LetsBet: () => { }
})

export default function BetProvider({ children }: { children: ReactNode }) {
    const { user, loading, setUserPoint } = useContext(AuthContext)
    const [betTickets, setBetTickets] = useState<ticketsTypes[]>([])
    const [betSlipShow, setBetslipShow] = useState<boolean>(false)
    const [betDetailShow, setBetDetailShow] = useState<boolean>(false)
    const [slipButtonShow, setSlipButtonShow] = useState<boolean>(false)
    const [betslipInfo, setBetslipInfo] = useState<BetslipTypes>({ bet_point: 0, total_odds: 1, expected_point: 0 })

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    // detail
    const [detailList, setDetailList] = useState<betDetailTypes[]>([])
    const [totalCount, setTotalCount] = useState<number>(1)

    function LetsBet() {
        if (!user.is_authenticated) {
            customAlert(a("NeedLogin"), `warning`)
            return;
        }
        // console.log(betTickets)
        if (betTickets.length < 2) {
            customAlert(a("minSelectionsRequired"), `warning`)
            return;
        }
        if (betslipInfo.bet_point < 100) {
            customAlert(a("minPointsRequired"), `warning`)
            return;
        }

        const folders: { selection_id: number, odds: number }[] = []
        let someError: boolean = false;
        betTickets.some((ti) => {
            const now = new Date();
            const matchDate = new Date(ti.match_date);

            if (matchDate < now) {
                customAlert(a("ticketHasStartedMatch"), 'warning');
                someError = true
                return;
            }else{
                folders.push({
                    selection_id: ti.selections.selection_id,
                    odds: Number(ti.selections.odds)
                })
            }
        })

        if(someError) return;

        const data = {
            username: user.id,
            stake: betslipInfo.bet_point,
            folders: folders
        }
        const formData = new FormData()
        formData.set('username', user.id)
        // formData.set('username', `rickey`)
        formData.set('stake', `${betslipInfo.bet_point}`)
        formData.set('folders', JSON.stringify(folders))
        // console.log(JSON.stringify(data))
        // api(`/api/sports/betticket/`, { method: 'POST', body: formData })
        api(`/api/sports/betticket/`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then((data) => {
                customAlert(a('BetCompleted'), 'success')
                setBetTickets([])
                fetchBetDetails(1, 6)
                setUserPoint(data.user_balance)
            })
            .catch((error: Response) => {
                customAlert(a('BetFailed'), 'error')
                console.error(error)
            })
    }

    function deleteAllBetTickets(){
        if(!user.is_authenticated) return;

        const fromData = new FormData()
        fromData.set('username', user.id)
        api(`/api/sports/betticket/delete/`, { method: `POST`, body: fromData })
            .then(res=> res.json())
            .then(({message})=> {
                customAlert(message, 'success')
                fetchBetDetails(1, 10)
            })
            .catch((error: Response)=> {
                console.error(error)
                customAlert(a("ErrorRequest"), 'error')
            })
    }

    function fetchBetDetails(page: number, perPage: number) {
        if (loading || !user.is_authenticated) {
            return;
        }

        const queryString = {
            username: user.id,
            page: page,
            page_size: perPage,
        };

        api(`/api/sports/betticket/` + getQueryString(queryString))
            .then(res => res.json())
            .then(({ data, total_pages }) => {
                const totalCount = perPage * total_pages;

                setDetailList(data)
                setTotalCount(totalCount)
            })
    }

    function SetBetTickets(match_id: number, match_date: string, members: membersType[], markets: marketType, selections: selectionType) {

        setBetTickets((before) => {
            // 크로스 불가 (동일 매치 아이디 체크)
            // match_id가 이미 존재하는 경우 해당 항목 제거
            const filtered = before.filter((ti) => ti.match_id !== match_id);

            // 새로운 항목 추가
            return [
                ...filtered,
                {
                    match_id,
                    match_date,
                    members,
                    markets,
                    selections,
                },
            ];
        });
    }
    function clearTicket() {
        setBetTickets([])
        setBetslipInfo(prev => {
            return {
                ...prev,
                total_odds: 1
            };
        });
    }
    function deleteSelection(selection_id: number) {
        setBetTickets((before) => {
            // selections_id가 이미 존재하는 경우 해당 항목 제거
            const filtered = before.filter((ti) => ti.selections.selection_id !== selection_id);

            // 새로운 항목 추가
            return [...filtered];
        });
    }
    function addBetPoint(num: number) {
        setBetslipInfo(prev => {
            const { bet_point, total_odds, expected_point } = prev;
            const totalPoint = bet_point + num
            if (totalPoint > 1000) {
                customAlert(a("maxPointsAllowed"), 'warning')
                return { ...prev };
            }
            return {
                ...prev,
                bet_point: bet_point + num
            };
        });
    }
    useEffect(() => {
        if (betDetailShow) {
            fetchBetDetails(1, 10);
        }
    }, [betDetailShow])
    useEffect(() => {
        // console.log(betslipInfo)
        setBetslipInfo(prev => {
            const { bet_point, total_odds, expected_point } = prev;

            return {
                ...prev,
                expected_point: Math.floor(bet_point * Number(total_odds))
            };
        });
    }, [betslipInfo.bet_point, betslipInfo.total_odds])
    useEffect(() => {
        if (betTickets.length) {
            setSlipButtonShow(true)
        }

        let totalOdds = 1
        betTickets.forEach((el) => {
            totalOdds *= Number(el.selections.odds)
        })
        const totalOdds_end = Number(totalOdds).toFixed(2)
        // ✅ 만약 총 배당률이 99 초과라면 가장 최근 항목 제거
        if (Number(totalOdds_end) > 99) {
            customAlert(a("maxOddsExceeded"), 'warning')
            setBetTickets((prev) => prev.slice(0, -1)); // 마지막 항목 제거
            return; // 이후 계산 중단
        }

        setBetslipInfo(prev => {
            const { bet_point, ...others } = prev;
            return {
                ...prev,
                total_odds: totalOdds_end
            };
        });
    }, [betTickets])

    const returnProps = {
        betTickets,
        SetBetTickets,
        clearTicket,
        betSlipShow,
        setBetslipShow,
        betDetailShow,
        setBetDetailShow,
        betslipInfo,
        setBetslipInfo,
        addBetPoint,
        deleteSelection,
        fetchBetDetails,
        detailList,
        totalCount,
        deleteAllBetTickets,
        LetsBet
    }
    return (
        <BetContext.Provider value={returnProps} >
            {children}
            {slipButtonShow && <BetslipButton setBetslipShow={setBetslipShow} betSlipShow={betSlipShow} />}
            <FloatBetslip />
            <FloatBetDetail />
        </BetContext.Provider>
    )
}

function BetslipButton({ setBetslipShow, betSlipShow }: { setBetslipShow: Function, betSlipShow: boolean }) {
    return <>
        <div className="betting-slip-button-container" onClick={e => setBetslipShow(!betSlipShow)}>
            <div className="button-container">
                <span className="slip_icon"></span>
                <p>BETTING SLIP</p>
            </div>
        </div>
    </>
}